import React, { useRef, useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Sidebar.scss";
import { CiCirclePlus, CiSearch } from "react-icons/ci";
import { FaFilter } from "react-icons/fa";

const Sidebar = ({
  activeTab,
  setActiveTab,
  showSearch,
  setShowSearch,
  testCases,
  testScenarios,
  setSelectedTestCase,
  getTestCaseById,
  GET_TESTSCENARIO_BY_ID,
  GET_TESTCASE_BY_ID,
  fetchData,
  API_URLS,
  userId,
  handleTabChange,
  IdToken,
  setStoreSingelRes,
}) => {
  const sidebarRef = useRef(null);
  const resizerRef = useRef(null);
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    const resizer = resizerRef.current;
    const sidebar = sidebarRef.current;

    const handleMouseDown = () => {
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    };

    const handleMouseMove = (e) => {
      const newWidth = Math.min(Math.max(e.clientX, 180), 400);
      sidebar.style.width = `${newWidth}px`;
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    resizer.addEventListener("mousedown", handleMouseDown);
    return () => resizer.removeEventListener("mousedown", handleMouseDown);
  }, []);

  const handleCreateSelect = (key) => {
    handleTabChange(key);
    setShowMenu(false);
  };

  const handleItemClick = (item) => {
    setStoreSingelRes(item);
    if (activeTab === "testScenario") {
      getTestCaseById(item, GET_TESTSCENARIO_BY_ID);
    } else {
      getTestCaseById(item, GET_TESTCASE_BY_ID);
    }
    // setSelectedTestCase(item);
  };

  const itemsToDisplay =
    activeTab === "testScenario"
      ? testScenarios?.test_scenarios
      : testCases?.test_cases;
  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
  
    if (!itemsToDisplay || !Array.isArray(itemsToDisplay)) {
      console.warn("itemsToDisplay is not available or not an array");
      return;
    }
  
    const filteredItems = itemsToDisplay.filter((item) => {
      const desc = item.user_story_description || "";
      const id = item.user_story_id || "";
  
      return (
        desc.toLowerCase().includes(searchValue) ||
        id.toLowerCase().includes(searchValue)
      );
    });
  
    setStoreSingelRes(filteredItems);
  };
  
  return (
    <>
      <div ref={sidebarRef} className="custom-sidebar">
        <div className="sidebar-create px-3 pt-3 pb-2 position-relative">
          <button
            className="createnewbtn rounded d-flex align-items-center justify-content-between px-3 py-2 btn btn-light"
            style={{ fontWeight: 500 }}
            onClick={() => setShowMenu(!showMenu)}
          >
            <span>Create New Test</span>
            <CiCirclePlus style={{ width: 28, height: 28 }} />
          </button>
          {showMenu && (
            <div className="custom-dropdown">
              <div
                className="dropdown-item"
                onClick={() => handleCreateSelect("testScenario")}
              >
                Create Test Scenario
              </div>
              <div
                className="dropdown-item"
                onClick={() => handleCreateSelect("testCase")}
              >
                Create Test Case
              </div>
            </div>
          )}
        </div>

        <div className="bordered-section sidebar-controls d-flex align-items-center justify-content-between px-3 pt-2 pb-2">
          <h6 className="text-dark mb-0">Recent</h6>
          <div className="d-flex gap-2">
            {/* {showSearch ? (
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Enter search value"
                onBlur={() => setShowSearch(false)}
                onChange={handleSearch}
                autoFocus
              />
            ) : (
              <CiSearch
                style={{
                  width: 30,
                  height: 30,
                  color: "#6c757d",
                  cursor: "pointer",
                }}
                onClick={() => setShowSearch(true)}
              />
            )}

            <button className="btn btn-outline-dark btn-sm d-flex align-items-center gap-1">
              <FaFilter /> Filters
            </button> */}
          </div>
        </div>

        <div
          className="sidebar-tabs px-3"
          style={{ height: "100%", display: "flex", flexDirection: "column" }}
        >
          <div
            className="btn-group w-100 mb-2"
            style={{
              border: "1px solid #eae6e6",
              borderRadius: "0.25rem",
            }}
          >
            <button
              className={`btn btn-light btn-sm w-50 ${
                activeTab === "testScenario" ? "active" : ""
              }`}
              onClick={() => handleTabChange("testScenario")}
            >
              Test Scenario
            </button>
            <button
              className={`btn btn-light btn-sm w-50 ${
                activeTab === "testCase" ? "active" : ""
              }`}
              onClick={() => handleTabChange("testCase")}
            >
              Test Case
            </button>
          </div>

          <div
            className="sidebar-list"
            style={{
              overflowY: "auto",
              flex: 1,
              maxHeight: "calc(100vh - 200px)", // adjust if needed
            }}
          >
            {itemsToDisplay?.length === 0 ? (
              <div className="text-muted px-2">No items available</div>
            ) : (
              itemsToDisplay?.map((item) => (
                <div
                  key={item.doc_id}
                  className="p-2 mb-2 rounded bg-white shadow-sm text-dark"
                  onClick={() => handleItemClick(item)}
                  style={{
                    fontSize: "13px",
                    cursor: "pointer",
                    maxWidth: "100%", // don't overflow container
                    width: "100%", // fill parent container
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                    whiteSpace: "normal",
                  }}
                >
                  <div className="fw-bold" style={{ fontSize: "13px" }}>
                    {activeTab === "testScenario"
                      ? `Scenario ID: ${item.user_story_id || "N/A"}`
                      : `Test Case ID: ${item.user_story_id || "N/A"}`}
                  </div>
                  <div
                    className="text-muted"
                    style={{
                      fontSize: "13px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                      whiteSpace: "normal",
                      maxWidth: "100%", // important!
                    }}
                  >
                    {item?.user_story_description || "No description"}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
      <div ref={resizerRef} className="resizer" />
    </>
  );
};

export default Sidebar;
